var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex z-20 justify-center items-center speech-bubble speech-bubble:after absolute left-0 top-10 w-72 h-18 bg-white shadow-xl border border-customSoftGray rounded-lg"},[_c('h2',{staticClass:"text-xs text-center w-9/12"},[_vm._v(_vm._s(_vm.information))]),_vm._v(" "),_c('div',{attrs:{"id":"arrow","data-popper-arrow":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }